import {
  TrackingProduct,
  TrackingProductCategory,
  TrackingVariant,
} from '../../../types';
import {getCategory} from '../helpers/category';
import {TrackingClientStateHolder} from '../helpers/clientState';
import {getStateFullDataLayerProduct} from '../helpers/product';
import {DetailPageEvent, DetailPageEventGA4} from './trackAdpView';

export const trackAdpSizeChange =
  ({
    product,
    variant,
    productCategories,
  }: {
    product: TrackingProduct;
    variant: TrackingVariant;
    productCategories: TrackingProductCategory[];
  }) =>
  (clientState: TrackingClientStateHolder): DetailPageEvent => {
    const currentState = clientState.getCurrent();
    const {currentPage} = currentState;

    const category = getCategory({
      productCategories,
      state: currentState,
    });

    const {product: productGA} = getStateFullDataLayerProduct({
      currentState,
      product,
      variant,
      element: undefined,
      section: undefined,
      category,
      productUnitPrice: product.unitPrice,
    });

    const eventGA4: DetailPageEventGA4 = {
      event: 'view_item',
      content_name: currentPage?.page?.path || '',
      page_type: currentPage?.page?.type || '',
      page_type_id:
        currentPage?.type === 'detailed' ? `${currentPage.page?.id || ''}` : '',
      ecommerce: {
        items: [productGA],
      },
    };

    return {
      GA4: eventGA4,
    };
  };
